import { get } from "lodash";
import prisma from "libraries/prisma/client";
import uuidv4 from 'uuid/v4'

class PrismaSubscriber {
	static default = {
		id: "",
		email: "",
		referral_link: "",
		num_referred: 0,
		referrer: "",
		shared_story_link_quota: 0
	};

	static id = prismaSubscriber => get(prismaSubscriber, "id", PrismaSubscriber.default.id);

	static email = prismaSubscriber => get(prismaSubscriber, "email", PrismaSubscriber.default.email);

    static async recordReferral(referralCode) {
        try {
            const numReferred = await prisma.subscriber({ referral_link: referralCode }).num_referred()
            const subscriber = await prisma.updateSubscriber({ where: { referral_link: referralCode }, data: { num_referred: numReferred+1 } })
        } catch(error) {
            console.log("recordReferral", error)
        }
    }

	static referralLink = prismaSubscriber =>
		get(prismaSubscriber, "referral_link", PrismaSubscriber.default.referral_link);

	static numReferred = prismaSubscriber =>
		get(prismaSubscriber, "num_referred", PrismaSubscriber.default.num_referred);

	static referrer = prismaSubscriber =>
		get(prismaSubscriber, "referrer", PrismaSubscriber.default.referrer);

	static sharedStoryLinkQuota = prismaSubscriber =>
        get(prismaSubscriber, "shared_story_link_quota", PrismaSubscriber.default.shared_story_link_quota);
        
	static async fetch(email) {
		const prismaSubscriber = await prisma.subscriber({ email });
		return prismaSubscriber;
    }
    
    static async createOrUpdateWith(email: string, referrerEmail: string) {
        let referralCode = uuidv4()
        let referrer = referrerEmail
        const subscriber = await prisma.upsertSubscriber({
            where: { email },
            update: { email, referrer },
            create: {
                email,
                referral_link: referralCode,
                num_referred: 0,
                shared_story_link_quota: 3,
                referrer 
            }
        })
        return subscriber
    }
}

export default PrismaSubscriber;
